<template>
    <div class="row">
        <div class="col-lg-6 col-md-6">
            <div class="story_line" v-if="data.previous_blog">
                <div class="story_img">
                    <router-link :to="localePath('/blog/'+data.previous_blog.slug)">
                        <img class="radious_eight" height="144" width="95" :src="data.previous_blog.image" :alt="data.previous_blog.title" />
                    </router-link>
                </div>
                <div class="story text">
                    <router-link :to="localePath('/blog/'+data.previous_blog.slug)">
                        <span>previous story</span>
                        <p class="mb-0 font-active">
                            {{ data.previous_blog.title }}
                        </p>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 next_story">
            <div class="story_line" v-if="data.next_blog">
                <div class="story_img">
                    <router-link :to="localePath('/blog/'+data.next_blog.slug)">
                        <img class="radious_eight" height="144" width="95" :src="data.next_blog.image" :alt="data.next_blog.title" />
                    </router-link>
                </div>
                <div class="story text">
                    <router-link :to="localePath('/blog/'+data.next_blog.slug)">
                        <span>next story</span>
                        <p class="mb-0 font-active">
                            {{ data.next_blog.title }}
                        </p>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { data } = defineProps(['data'])
</script>

<style scoped>
.story_line {
    display: flex;
    align-items: center;
    max-width: 400px;
    width: 100%;
}

.story.text a {
    color: #000;
}

.story.text span {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    display: block;
    margin-bottom: 12px;
}

.story.text p {
    font-size: 18px;
}

.story_img {
    width: 30%;
}

.story.text {
    width: 70%;
}
.next_story {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

@media(max-width: 767px){
    .next_story {
        margin: 20px 0 !important;
        justify-content: flex-start;
    }
}
@media(max-width: 1150px){
    .story.text p {
        font-size: 18px;
    }
    .next_story{
        /* margin-top: 40px; */
    }
    .story.text p {
        font-size: 16px;
    }
    .story.text{
        padding-left: 15px;
    }
}
</style>
